import { render, staticRenderFns } from "./alert.vue?vue&type=template&id=a38395f2&scoped=true&"
import script from "./alert.vue?vue&type=script&lang=js&"
export * from "./alert.vue?vue&type=script&lang=js&"
import style0 from "./alert.vue?vue&type=style&index=0&id=a38395f2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a38395f2",
  null
  
)

export default component.exports